<template>
  <v-container
    fluid
    py-0
  >
    <div class="d-flex align-center justify-space-between flex-wrap">
      <div>
        <div class="d-flex align-center">
          <v-btn
            v-if="showBack"
            icon
            class="v-btn-titlebar"
            @click="goBack()"
          >
            <v-icon class="left"> $fas fa-arrow-left </v-icon>
          </v-btn>
          <h3
            v-if="showTitle"
            class="my-0"
          >
            {{ $t(title) }}
          </h3>
          <v-btn
            v-if="showCreate"
            fab
            color="primary"
            elevation="0"
            class="mx-4 v-size--tiny"
            @click="$emit('create')"
          >
            <v-icon> $fas fa-plus </v-icon>
          </v-btn>
          <v-btn
            v-if="showInfo"
            elevation="0"
            class="btn-info-circle"
            @click="$emit('info')"
          >
            <v-icon>$fas fa-info</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="d-flex" style="gap: 12px;">
        <slot/>
        <v-select
            v-if="showMixSelector"
            :items="mixItems"
            :item-text="'mixDesignCode'"
            :item-value="'_id'"
            :value="mixSelectedItem"
            single-line
            hide-details
            class="variation-selector"
            @change="onMixChange"
          />
        <v-select
          v-if="showSelector"
          :items="items"
          :item-value="'_id'"
          :label="$t(label)"
          :value="selectedItem"
          prepend-icon="$fas fa-industry"
          class="custom"
          style="max-width: 560px;"
          hide-details
          @change="onChange"
        >
          <template
            slot="item"
            slot-scope="data"
          >
            {{ plantIdentifier(data.item) }}
          </template>
          <template
            slot="selection"
            slot-scope="data"
          >
            {{ plantIdentifier(data.item) }}
          </template>
        </v-select>
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: 'views.production-technician.plant',
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    showCreate: {
      type: Boolean,
      default: false,
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    showSelector: {
      type: Boolean,
      default: true,
    },
    selectedItem: {
      type: String,
      required: false,
      default: '',
    },
    showMixSelector: {
      type: Boolean,
      default: false,
    },
    mixItems: {
      type: Array,
      required: false,
      default: () => [],
    },
    mixSelectedItem: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    title() {
      if (typeof this.$route.meta.name === 'function') {
        return this.$route.meta.name(this.$route)
      }
      return this.$route.meta.name ? this.$route.meta.name : ''
    },
  },
  methods: {
    onChange(item) {
      this.$emit('factory-change', item)
    },
    onMixChange(item) {
      this.$emit('mix-change', item)
    },
    goBack() {
      return this.$router.go(-1)
    },
    plantIdentifier(item) {
      return (
        item.supplierNumber +
        (item.supplierName ? ' - ' + item.supplierName : '')
      )
    },
  },
}
</script>
